function loadItems(button) {
  const totalPages = parseInt(
    document.querySelector("[data-total-pages]").value,
    10
  );
  let currentPage = parseInt(
    document.querySelector("[data-current-page]").value,
    10
  );
  let currentPageScroll = currentPage + 1;

  currentPage = currentPage + 1;

  const rawValue = document.querySelector("[data-next-url]").value;

  const getUrlWithoutPhcursor = (value, pageValue) => {
    const url = new URL(value, window.location.origin);
    url.searchParams.set("page", pageValue);
    url.searchParams.delete("phcursor");
    return url.pathname + "?" + url.searchParams.toString();
  };

  const nextUrl = getUrlWithoutPhcursor(rawValue, currentPage);
  const nextUrlScroll = getUrlWithoutPhcursor(rawValue, currentPageScroll);

  document.querySelector("[data-current-page]").value = currentPage;

  // §89 r5: read the focus BEFORE disabling the button; a disabled button
  // loses focus to <body> at once, so r4's check inside the fetch callback
  // was always false (QA r4) and keyboard users were dropped to the top
  const mgHadFocus = document.activeElement === button;
  button.setAttribute("disabled", "");
  button.classList.add("loading");

  fetch(nextUrl)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.text();
    })
    .then((responseHTML) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(responseHTML, "text/html");
      const newGrid = doc.querySelector(".load-more-grid");
      const wrapper = document.querySelector(".load-more-grid");
      if (!newGrid || !wrapper) {
        throw new Error("Grid element not found");
      }
      const newItems = newGrid.innerHTML;
      // §89 r4: remember where the new pieces start (focus: see above)
      const mgBefore = wrapper.children.length;
      wrapper.insertAdjacentHTML("beforeend", newItems);

      if (doc.getElementById("LoadMoreProgress")) {
        updateProgressLabel(responseHTML);
        updateProgressbar(currentPage, totalPages);
      }
      mgAfterLoad(wrapper, mgBefore, mgHadFocus, currentPage >= totalPages);
    })
    .catch((error) => {
      console.error("Error loading items:", error);
      button.removeAttribute("disabled");
      button.classList.remove("loading");
    })
    .finally(() => {
      if (currentPage <= totalPages) {
        const scrollData = document.querySelector(".infinite-scroll__data");
        if (scrollData && currentPage !== totalPages) {
          const nextUrlInput = scrollData.querySelector("input[data-next-url]");
          const currentPageInput = scrollData.querySelector(
            "input[data-current-page]"
          );

          if (nextUrlInput) {
            nextUrlInput.dataset.nextUrl = nextUrlScroll;
            nextUrlInput.value = nextUrlScroll;
          }

          if (currentPageInput) {
            currentPageInput.dataset.currentPage = currentPage;
            currentPageInput.value = currentPage;
          }

          checkVisibility();
        }

        button.removeAttribute("disabled");
        button.classList.remove("loading");

        if (currentPage === totalPages) {
          button.remove();
        }
      }
    });
}

function checkVisibility() {
  const spinnerList = document.querySelectorAll(".js-infinite-scroll");
  spinnerList.forEach((spinner) => {
    const sectionObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadItems(spinner);
          sectionObserver.unobserve(entry.target);
        }
      });
    });

    sectionObserver.observe(spinner);
  });
}

function updateProgressLabel(html) {
  const count =
    new DOMParser()
      .parseFromString(html, "text/html")
      .getElementById("LoadMoreProgress")?.innerHTML || "";
  const container = document.getElementById("LoadMoreProgress");
  if (container) {
    container.innerHTML = count;
  }
}

function updateProgressbar(current, total) {
  const progressbar = document.getElementById("LoadMoreProgressBar");
  if (progressbar) {
    progressbar.style.width = `${(current / total) * 100}%`;
  }
}

// §89 r4/r5 (collection grid): "Showing X of Y" counts the pieces on the
// page (the grid hides non-merchandise add-ons); Y is the section's exact
// total (r5), and the label is absent when the section has none. Focus
// moves to the first new piece's name, so a keyboard user is never dropped
// to <body>.
// QA fix r2: the section prints the label on page 1 only (data-mg-from).
// The card count stands in for the total at the end only when the grid
// started on page 1, where it holds every piece; otherwise the printed
// total is kept.
function mgAfterLoad(wrapper, before, hadFocus, last) {
  if (!wrapper.classList.contains("collection-product-list")) return;
  const label = document.getElementById("LoadMoreProgress");
  const cards = wrapper.querySelectorAll(
    ":scope > .collection-product-card:not(.collection-promo-tile)"
  );
  if (label && label.dataset.mgLabel) {
    const n = cards.length;
    const fromStart = label.dataset.mgFrom === "1";
    const total =
      last && fromStart ? n : parseInt(label.dataset.mgTotal, 10) || n;
    label.dataset.mgTotal = total;
    label.textContent = label.dataset.mgLabel
      .replace("[current]", n)
      .replace("[total]", total);
    const bar = document.getElementById("LoadMoreProgressBar");
    if (bar) bar.style.width = `${Math.min(100, (n / total) * 100)}%`;
  }
  if (hadFocus) {
    const first = [...wrapper.children]
      .slice(before)
      .find((el) => !el.classList.contains("collection-promo-tile"));
    first
      ?.querySelector(".product-card__title a, a")
      ?.focus({ preventScroll: true });
  }
}

function initLoadMore() {
  document.querySelectorAll(".js-load-more").forEach((button) => {
    button.onclick = () => {
      loadItems(button);
    };
  });

  checkVisibility();
}

(function () {
  initLoadMore();
})();
